export function resolveAuthRuntimeDb<TDb>(params: {
  db: TDb;
  systemDb?: TDb | null;
  platformSystemDb: TDb;
  isBaas: boolean;
  isPlatform: boolean;
}): TDb {
  if (params.isPlatform) return params.platformSystemDb;
  if (params.isBaas && params.systemDb) return params.systemDb;
  return params.db;
}
